'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter('dateCustom', function ($dateFormat) {
  return function (date, format) {
    if (date == null) {
      return '';
    }
    return $dateFormat.custom(date, format);
  };
});

/**
 * ex : (fr) Lundi 12 Mars 2013
 */
ngModule.filter('date', function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.date(date);
  };
});

/**
 * ex : 31/10/2015
 */
ngModule.filter('dateShort', function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.short(date);
  };
});

/**
 * ex : 31/10/2015 14:14
 */
ngModule.filter('dateMedium', function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.medium(date);
  };
});

/**
 * * ex : (fr) 21/09/2012 14:52:10
 */
ngModule.filter('dateLong', function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.long(date);
  };
});

/**
 * * ex : 14:52:10
 */
ngModule.filter('time', function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.time(date);
  };
});
ngModule.filter('elapseDays', function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    } else {
      if (moment.duration(date).asDays() >= -1 && moment.duration(date).asDays() < 1) {
        // todo - i8n
        return "aujourd'hui";
      }
    }
    return moment.duration(date).humanize(true);
  };
});
ngModule.filter('dateUrlShort', function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.urlShort(date);
  };
});
ngModule.filter('dateServer', function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.server(date);
  };
});
ngModule.filter('dateYear', function ($dateFormat) {
  // TODO : rename to getYear
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.year(date);
  };
});
ngModule.filter('dateDayOfMonth', function ($dateFormat) {
  // TODO : rename to get...
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.custom(date, 'DD');
  };
});
ngModule.filter("getLongMonth", function ($dateFormat) {
  return function getLongMonth(date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.custom(date, "MMMM");
  };
});
ngModule.filter('longMonthAndYear', function ($dateFormat, $dateDisplayFormats) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.custom(date, $dateDisplayFormats.MONTH_AND_YEAR);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/date/dateFilters.js
// module id = 2724
// module chunks = 13